<div class="bg-container" >
  <div class="container" *ngIf="isVisible">
    <div class="item">
      <a [routerLink]="'/'"><img src="../../../../assets/img/beta_logo_disclaimer.png" class="logo-icon" alt="fruzty-logo"/></a>
    </div>
    <div class="item padding-lat">
      <p>{{ 'HomeHeader.Disclaimer.Message' | translate }}</p>
    </div>
    <div class="item">
      <div class="section-btn">
        <button pButton (click)="openDisclaimerDialog()" class="ghost-btn">{{ 'HomeHeader.Disclaimer.MoreInfo' | translate }}</button>
        <button (click)="closeDisclaimer()" class="circle-figure">
          <i class="pi pi-times" style="font-size: 1rem"></i>
        </button>
      </div>
    </div>
  <!--
  <div class="grid flex align-items-center">
    <div class="col-4 md:col-1 flex justify-content-center align-items-center">
      <a [routerLink]="'/'"><img src="../../../../assets/img/beta_logo_disclaimer.png" style="width: 100px;" alt="fruzty-logo"/></a>
    </div>
    <div class="col-8 md:col-9 flex justify-content-center align-items-center">
      <p>{{ 'HomeHeader.Disclaimer.Message' | translate }}</p>
    </div>
    <div class="col-12 md:col-2 flex justify-content-center align-items-center">
      <button pButton (click)="openDisclaimerDialog()" style="background-color: #3C1A43; border: 1px solid #FFFFFF; border-radius: 5px; color: #FFFFFF; width: auto; max-width: 180px; height: 40px;">{{ 'HomeHeader.Disclaimer.MoreInfo' | translate }}</button>
    </div>

  </div>
-->
</div>


<p-dialog [resizable]="false" [modal]="true" [draggable]="false" [(visible)]="visibleDisclaimerESPDialog" [style]="{width: '80%'}">
  <div class="grid flex align-items-center" style="padding: 0 20px;">
    <div class="col-12 md:col-4 flex justify-content-center align-items-center">
      <img src="../../../../assets/img/beta_image_modal.png" style="width: 100%; max-width: 450px;" alt="fruzty-logo"/>
    </div>
    <div class="col-12 md:col-8 flex justify-content-center align-items-start flex-column" style="font-size: 1.2rem">
      <p style="color: #6EC116; margin-bottom: 40px; font-weight: bolder;">{{ 'HomeHeader.Disclaimer.Greeting' | translate }},</p>

      <p style="text-align: justify; margin: 7px 0">
        Le damos la bienvenida a la <span style="background-color: #6EC116; color: #FFF">versión beta de Fruzty.com.</span> Al continuar, usted acepta que está navegando en una versión preliminar que aún se encuentra en desarrollo. Es posible que no incluya todas las funcionalidades y características finales de la plataforma completa. Le notificaremos oportunamente cuando la plataforma avance a una nueva versión.
      </p>
      <p style="text-align: justify; margin: 7px 0">
        Durante este período de pruebas, apreciamos tu paciencia y comprensión ante cualquier inconveniente que pueda experimentar. Tus comentarios y sugerencias son invaluables para nosotros y serán fundamentales para perfeccionar nuestra plataforma. <span style="color: #672572; font-weight: bolder;">Para compartir sus impresiones o reportar algún problema, contáctenos en info@fruzty.com.</span>
      </p>
      <p style="text-align: justify; margin: 7px 0">
        Estamos trabajando para mejorar y completar nuestra oferta de servicios. Gracias por contribuir al futuro de Fruzty.com.
      </p>
      <div style="margin: 20px auto">
        <button pButton (click)="closeDisclaimerDialog()" style="background-color: #6EC116; border-radius: 5px; color: #FFFFFF; width: auto; max-width: 180px; height: 40px;">{{ 'HomeHeader.Disclaimer.Aceptation' | translate }}</button>
      </div>
    </div>
  </div>
</p-dialog>


<p-dialog [resizable]="false" [modal]="true" [draggable]="false" [(visible)]="visibleDisclaimerENGDialog" [style]="{width: '80%'}">
  <div class="grid flex align-items-center" style="padding: 0 20px;">
    <div class="col-12 md:col-4 flex justify-content-center align-items-center">
      <img src="../../../../assets/img/beta_image_modal.png" style="width: 100%; max-width: 450px;" alt="fruzty-logo"/>
    </div>
    <div class="col-12 md:col-8 flex justify-content-center align-items-start flex-column" style="font-size: 1.2rem">
      <p style="color: #6EC116; margin-bottom: 40px; font-weight: bolder;">{{ 'HomeHeader.Disclaimer.Greeting' | translate }},</p>

      <p style="text-align: justify; margin: 7px 0">
        Welcome to the  <span style="background-color: #6EC116; color: #FFF">beta version of Fruzty.com.</span> By continuing, you agree that you are browsing a preview version that is still in development. It may not include all the final functionalities and features of the full platform. We will notify you in a timely manner when the platform advances to a new version.
      </p>
      <p style="text-align: justify; margin: 7px 0">
        We appreciate your patience and understanding for any inconvenience you may experience during this testing phase. Your feedback and suggestions are invaluable to us and are essential in perfecting our platform. <span style="color: #672572; font-weight: bolder;">To share your impressions or report any problems, contact us at info@fruzty.com.</span>
      </p>
      <p style="text-align: justify; margin: 7px 0">
        We are always working to improve and complete our services. Thank you for your contribution to the future of Fruzty.com.
      </p>
      <div style="margin: 20px auto">
        <button pButton (click)="closeDisclaimerDialog()" style="background-color: #6EC116; border-radius: 5px; color: #FFFFFF; width: auto; max-width: 180px; height: 40px;">{{ 'HomeHeader.Disclaimer.Aceptation' | translate }}</button>
      </div>
    </div>
  </div>
</p-dialog>


